var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { OfficeService } from '../../services/office.service';
import { AgentService } from '../../services/agent.service';
import { Agent } from '../../classes/agent';
import { Office } from '../../classes/office';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { HasSubscriptions } from '../has-subscriptions';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, merge } from 'rxjs';
import { PreferencesService } from '../../services/preferences.service';
import { CommunicationService } from '../../services/communication.service';
import { ListingCategory, SCREEN_SIZE, SearchType } from '../../classes/enums';
import { Pagination } from '../../classes/pagination';
import { ActivatedRoute, Router } from '@angular/router';
import { PreRenderService } from '../../services/pre-render.service';
import { HistoryItem } from '../../classes/history-item';
import { FiltersSearch } from '../../components/filters/filters-search/filters-search';
import { RoutingHistoryService } from '../../services/routing-history.service';
import { RemaxLeadEntity, MapOfficeToLead, MapAgentToLead, nameRegex, emailRegex } from '../../classes/leads';
import { MetaTagService } from '../../services/meta-tag.service';
import { SearchFiltersParams } from '../../classes/search-filters-params';
import { BlogService } from '../../services/blog.service';
import { IBlogResponse, IBlogItem } from '../../classes/interfaces';
import { get } from 'lodash-es';
import { INFINITE_SCROLL } from '../../classes/analytics-tags';
import { AnalyticsService } from '../../services/analytics/analytics.service';
var SearchPageComponent = /** @class */ (function (_super) {
    __extends(SearchPageComponent, _super);
    function SearchPageComponent(_officeService, _agentService, _userService, _preferencesService, _communicationService, _fb, _prerenderService, historyService, activatedRoute, _metaTagsService, router, translate, blogService, analytics) {
        var _this = _super.call(this) || this;
        _this._officeService = _officeService;
        _this._agentService = _agentService;
        _this._userService = _userService;
        _this._preferencesService = _preferencesService;
        _this._communicationService = _communicationService;
        _this._fb = _fb;
        _this._prerenderService = _prerenderService;
        _this.historyService = historyService;
        _this.activatedRoute = activatedRoute;
        _this._metaTagsService = _metaTagsService;
        _this.router = router;
        _this.translate = translate;
        _this.blogService = blogService;
        _this.analytics = analytics;
        _this.pagination = new Pagination();
        _this.items = [];
        _this.showContactLeadForm = false;
        _this.leadInfo = {};
        _this.showRequestSent = false; // Has the message been sent
        _this.nameToDisplayForRequestSent = ''; // The name that's shown when we submit a request for the contact form
        _this.isFetchingItems = false;
        _this.searchType = SearchType.OFFICE; // uses office as default
        _this._isFirstRequest = true; // We need to check if its the first request, in case they pass in a page as a parameter so we know whether or not to ignore it
        // Enums
        _this.Office = Office;
        _this.Agent = Agent;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.SearchType = SearchType;
        _this.ListingType = ListingCategory;
        _this.schemas = [];
        // If they're coming in from the popular agents page
        _this.isPopularAgentPage = false;
        // TODO: messaging stating that they need to enter something
        _this.searchForm = _this._fb.group({ searchInput: ['', Validators.minLength(1)] });
        return _this;
    }
    SearchPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._prerenderService.setPreRenderFlag(200);
        this._setContactForm();
        this.addSub(combineLatest(this.activatedRoute.data, this.activatedRoute.params)
            .subscribe(function (value) {
            var data = value[0];
            var params = value[1];
            _this.setupInitialPageData(data, params);
        }));
        // for mobile the filters are contained in the drawer object, so we need to listen to changes on the communication service
        this.addSub(this._communicationService.filters.search.subscribe(function (filters) {
            _this.doSearch(filters);
        }));
        this.addSub(this._communicationService.screenSize.subscribe(function (s) {
            _this.screenSize = s;
            if (s === SCREEN_SIZE.MOBILE_ONLY)
                _this.pagination.limit = 10;
            else
                _this.pagination.limit = 16;
        }));
        this.addSub(this._communicationService.listings.currentShownListingType.subscribe(function (s) {
            _this.currentShownListingType = s;
        }));
        this.blogService.getByTags(['cms-officeagent-results-side']).toPromise()
            .then(function (results) {
            _this.ad = get(results, '[0].content');
        });
    };
    SearchPageComponent.prototype.showContactForm = function (contactObject) {
        this.showContactLeadForm = true;
        if (contactObject) {
            if (contactObject instanceof Office) {
                this.leadInfo = MapOfficeToLead(contactObject);
            }
            else {
                this.leadInfo = MapAgentToLead(contactObject);
            }
            this.contactForm.patchValue({
                comments: this.translate.instant('contact.generic-intro-with-name', { name: contactObject instanceof Office ? contactObject.officeName : contactObject.fullName })
            });
        }
    };
    SearchPageComponent.prototype.doSearch = function (filters) {
        this.searchFilters = filters;
        // If its the first request, we dont want to reset the page number since it might've been set with the page parameters
        if (this._isFirstRequest)
            this._isFirstRequest = false;
        else {
            // Every time they do a new search, we need to make sure we reset the page number
            this.pagination.pageNumber = 0;
        }
        this.getNewItems(this.pagination.pageNumber);
        this.getFooterLinks();
    };
    /**
     * Retrieves the new items for searching
     * If on Desktop, we'll switch the items completely because of pagination
     * but if we're on mobile, we'll append it because of infinite scrolling
     * @param newPageNumber The new page of items we want to fetch, if not present, we go back to page 0
     */
    SearchPageComponent.prototype.getNewItems = function (newPageNumber, isInfiniteScroll) {
        var _this = this;
        if (newPageNumber > 0) {
            if (this.pagination.totalResults === this.items.length)
                return;
            this.pagination.pageNumber = newPageNumber;
        }
        else {
            this.pagination.pageNumber = 0;
            this.items = [];
        }
        if (isInfiniteScroll) {
            this.analytics.eventTrack(INFINITE_SCROLL, null);
        }
        this.isFetchingItems = true;
        FiltersSearch.lastFilterSearch = this.searchFilters.text;
        switch (this.searchType) {
            case SearchType.AGENT:
                this._agentService.getAgents(this.pagination, this.searchFilters).then(function (i) {
                    _this.completeSearch(i);
                });
                break;
            case SearchType.OFFICE:
                this._officeService.getOffices(this.pagination, this.searchFilters).then(function (i) {
                    _this.completeSearch(i);
                });
                break;
        }
    };
    SearchPageComponent.prototype.completeSearch = function (i) {
        // TODO: this isn't working properly with fake searches
        this.pagination.setTotalResults(i.totalHits);
        // We need to do different things if its infinite scroll or pagination
        if (this.screenSize === SCREEN_SIZE.MOBILE_ONLY)
            this.items = this.items.concat(i.results);
        else
            this.items = i.results;
        this.schemas = this.items.map(function (item) { return item.jsonLdSchema; });
        this.isFetchingItems = false;
        this._communicationService.filters.totalHits.next(i.totalHits);
    };
    /**
     * Set properties for the contact lead form based on whether they're signed in or not and the options they select
     */
    SearchPageComponent.prototype._setContactForm = function () {
        var _this = this;
        this.contactForm = new FormGroup({
            name: new FormControl('', { validators: [Validators.required, Validators.pattern(nameRegex)], updateOn: 'blur' }),
            email: new FormControl('', { validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'blur' }),
            contactByPhone: new FormControl(false),
            contactType: new FormControl('no-pref'),
            buy: new FormControl(false),
            sell: new FormControl(false),
            comments: new FormControl(''),
            phone: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(13)])
        });
        // TODO: SO MUCH DUPLICATION
        this.addSub(this._userService.currentUser.subscribe(function (user) { return _this._onReceiveCurrentUser(user); }));
        this.addSub(merge(this.contactForm.controls['buy'].valueChanges, this.contactForm.controls['sell'].valueChanges).subscribe(function () {
            var buy = _this.contactForm.controls['buy'].value;
            var sell = _this.contactForm.controls['sell'].value;
            // TODO: change this to use the with-name versions
            var commentsText = buy && sell
                ? _this.translate.instant('page-profile.looking-buy-and-sell')
                : (buy ? _this.translate.instant('page-profile.looking-buy')
                    : (sell ? _this.translate.instant('page-profile.looking-sell')
                        : ''));
            _this.contactForm.patchValue({
                comments: commentsText
            });
        }));
        this.addSub(this.contactForm.get('contactByPhone').valueChanges.subscribe(function (value) {
            if (value)
                _this.contactForm.controls['phone'].enable();
            else
                _this.contactForm.controls['phone'].disable();
            _this.contactForm.get('phone').updateValueAndValidity();
        }));
    };
    SearchPageComponent.prototype._onReceiveCurrentUser = function (user) {
        this._user = user;
        if (this._user.email) {
            // TODO: change this to use the with-name versions
            var commentsText = this._user.buy && this._user.sell
                ? this.translate.instant('page-page.looking-buy-and-sell')
                : (this._user.buy ? this.translate.instant('page-page.looking-buy')
                    : (this._user.sell ? this.translate.instant('page-page.looking-sell')
                        : ''));
            this.contactForm.patchValue({
                email: this._user.email,
                name: this._user.name,
                buy: this._user.buy,
                sell: this._user.sell,
                comments: commentsText
            });
        }
    };
    /**
     * Set up SEO related items, history service
     * @param value
     */
    SearchPageComponent.prototype.setupInitialPageData = function (data, params) {
        return __awaiter(this, void 0, void 0, function () {
            var speciality, propertyType, agentSearchFilters, historyItem;
            return __generator(this, function (_a) {
                if (params.type || data.type) {
                    if (params.type) {
                        this.searchType = params.type.toUpperCase();
                        if (params.option) {
                            this.searchForm = this._fb.group({ searchInput: ['', Validators.minLength(1)] });
                        }
                        this.doSearch(this._preferencesService.getOfficeSearchFilters());
                    }
                    else if (data.type) {
                        this.searchType = data.type.toUpperCase();
                        speciality = data.specialty || '';
                        propertyType = data.propertyType || '';
                        agentSearchFilters = new SearchFiltersParams();
                        agentSearchFilters.features = {
                            language: '',
                            propertyType: propertyType,
                            specialty: speciality,
                            serviceArea: '',
                            civicActivity: {
                                childrensMiracleNetwork: false,
                                canadianBreastCancerFoundation: false
                            }
                        };
                        this._preferencesService.updateSearchFilters(SearchType.AGENT, agentSearchFilters);
                    }
                }
                else {
                    this.searchType = data.cityAndProvince.searchType;
                }
                historyItem = this.searchType === SearchType.AGENT ? new HistoryItem({ fromSearchAgentPage: true }) : new HistoryItem({ fromSearchOfficePage: true });
                this.historyService.push(historyItem);
                if (data.cityAndProvince)
                    this._setupPageWithRouteData(data);
                else
                    this._setupPageWithRouteParams();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Prep the data needed for SEO if they're hitting the page from a /province/city-real-estate-agents page
     * @param data activatedRoute Data
     */
    SearchPageComponent.prototype._setupPageWithRouteData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var cityProvinceData, province, city, type, translateVars;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cityProvinceData = data.cityAndProvince;
                        return [4 /*yield*/, this.translate.get('provinces.' + cityProvinceData.province).toPromise()];
                    case 1:
                        province = _a.sent();
                        city = cityProvinceData.city.charAt(0).toUpperCase() + cityProvinceData.city.slice(1);
                        type = this.searchType === SearchType.AGENT ? 'agent-popular-city' : 'office-popular-city';
                        translateVars = {
                            city: city,
                            province: province,
                            numberOfAgents: cityProvinceData.numberOfAgents
                        };
                        this.isPopularAgentPage = this.searchType === SearchType.AGENT;
                        this.pagination.pageNumber = cityProvinceData.pageNumber;
                        this._setSEOItems(type, translateVars);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Prep the page needed for SEO if they're hitting it through the normal route /find-agent-office/agent or office
     */
    SearchPageComponent.prototype._setupPageWithRouteParams = function () {
        var type = this.searchType === SearchType.AGENT ? 'agent-search' : 'office-search';
        this._setSEOItems(type);
    };
    /**
     * Sets the page title, page description, and h1 text
     * @param type the meta tags key
     * @param translateVars content if any
     */
    SearchPageComponent.prototype._setSEOItems = function (type, translateVars) {
        var _this = this;
        this._metaTagsService.setPageTitle('meta-tags.' + type + '.title', translateVars);
        this._metaTagsService.setPageDescription('meta-tags.' + type + '.description', translateVars);
        this._metaTagsService.setOpenGraphTags([
            {
                name: 'title',
                content: 'meta-tags.' + type + '.title',
                variables: translateVars,
                isTranslateKey: true
            },
            {
                name: 'description',
                content: 'meta-tags.' + type + '.description',
                variables: translateVars,
                isTranslateKey: true
            },
        ]);
        this.translate.get('meta-tags.' + type + '.h1', translateVars).toPromise().then(function (text) { return _this.h1Text = text; });
    };
    SearchPageComponent.prototype.getFooterLinks = function () {
        this._communicationService.footerLinksChange.next({ city: this.searchFilters.text, province: this.searchFilters.text });
    };
    return SearchPageComponent;
}(HasSubscriptions));
export { SearchPageComponent };
